import { useReactiveVar } from '@apollo/client';
import type React from 'react';

import LibraryDownloadDialog from 'src/components/dialogs/LibraryDownloadDialog';
import viewStateVar from 'src/store/viewState';
import { CollectionNavigationWrapper } from './MediaNavWrappers';
import MediaPage from './MediaPage';

export default function SharedGalleryMediaPage(): React.JSX.Element {
  const viewState = useReactiveVar(viewStateVar);
  return (
    <>
      <CollectionNavigationWrapper shared={true}>
        <MediaPage isShared={true} />
      </CollectionNavigationWrapper>
      <LibraryDownloadDialog isOpen={!!viewState.libraryDownloadDialog} />
    </>
  );
}
